export class Choice {
    constructor(choiceDto) {
        this.name = choiceDto.name;
        this.players = choiceDto.players;
    }
    toDTO() {
        return {
            name: this.name,
            players: this.players
        };
    }
}
